<template>
<div v-if="!isPageLoading">
    <div v-if="hasGlobalAccess && (user != null || currentuser != null)">
        <v-card>
            <v-card-title v-show="!isLoggedInUserActive">
                <label style="color: red">{{ $t("msguserisnotactive") }}</label>
            </v-card-title>
        </v-card>
        <v-card v-show="isLoggedInUserActive">
            <v-autocomplete :items="alllangauges" v-bind:label="$t('selectlanguage')" v-model="selectedlanguage" item-text="language" item-value="id" dense filled @change="selectedLangChanged()"></v-autocomplete>
            <v-data-table :headers="headers" :items="languagesTable" :search="search" :footer-props="{
            itemsPerPageOptions: tableItemsPerPage,
            itemsPerPageText: rowsperpage,
          }" :options="options">
                <template v-slot:[`header.selectedLanguage`]="{ header }">
                    {{ (header.text = selectedlangText) }}
                </template>
                <template v-slot:top>
                    <v-toolbar flat dense>
                        <h3>{{ $t("languages") }}</h3>
                        <v-divider class="mx-4" inset vertical v-show="!isUpdateAllButtonActive"></v-divider>
                        <v-dialog v-model="dialog" max-width="500px">
                            <!-- Display status / error messages coming from api -->
                            <div id="error" v-show="dialog && statusmessages.length > 0">
                                <v-alert :value="true" type="error">
                                    <div>
                                        <ul>
                                            <li v-for="(status, index) in statusmessages" :key="index">
                                                {{ status.message }}
                                            </li>
                                        </ul>
                                    </div>
                                </v-alert>
                            </div>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                    <v-spacer></v-spacer>
                                    <v-icon @click="close(1)">close</v-icon>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-col cols="12" sm="8" md="8">
                                                <v-chip class="mb-2" large>{{
                            editedItem.key
                          }}</v-chip>
                                            </v-col>
                                            <v-col cols="12" sm="8" md="8">
                                                <v-text-field v-model="editedItem.english" v-bind:label="$t('english')"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="8" md="8" v-if="!isUpdateAllButtonActive">
                                                <v-text-field v-model="editedItem.selectedLanguage" v-bind:label="selectedlangText"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn color="blue darken-1" text @click="close(1)">{{
                      $t("cancel")
                    }}</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" dark class="mb-2" @click="save">{{
                      $t("save")
                    }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-dialog v-model="dialog1" max-width="900px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on" :disabled="isUpdateAllButtonActive">{{ $t("updateall") }}</v-btn>
                            </template>
                            <!-- Display status / error messages coming from api -->
                            <v-card>
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                    <v-spacer></v-spacer>
                                    <v-icon @click="close(1)">close</v-icon>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row v-for="item in languagesTable" :key="item.id">
                                            <v-col cols="12" sm="4" md="6">
                                                <v-text-field v-model="item.english" v-bind:label="item.key"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4" md="6">
                                                <v-text-field v-model="item.selectedLanguage" v-bind:label="selectedlangText"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn color="blue darken-1" text @click="close(1)">{{
                      $t("cancel")
                    }}</v-btn>
                                    <v-spacer></v-spacer>
                                    <v-btn color="primary" dark class="mb-2" @click="SaveLanguageData">{{ $t("saveall") }}</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-text-field v-model="search" append-icon="mdi-magnify" v-bind:label="$t('searchall')" single-line hide-details></v-text-field>
                    </v-toolbar>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                </template>
                <template v-slot:no-data>
                    <v-alert border="right" colored-border type="error" elevation="2">{{
              $t("norecordsfound")
            }}</v-alert>
                </template>
            </v-data-table>
            <v-btn color="primary" dark class="mb-2" :disabled="isSaveButtonActive" @click="SaveLanguageData()">Save All</v-btn>
        </v-card>
    </div>
    <div v-else-if="user != null || currentuser != null">
        <v-alert outlined type="warning" prominent border="left">{{
        $t("accessdenied")
      }}</v-alert>
    </div>
</div>
<div v-else>
    <v-progress-linear indeterminate color="teal" rounded height="8"></v-progress-linear>
</div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import i18n from "@/plugins/i18n";
import requestsMixin from "@/mixins/requests"

export default {
    mixins: [requestsMixin],
    data() {
        return {
            search: "",
            alllangauges: [],
            apilanguages: [],
            languagesTable: [],
            dialog: false,
            dialog1: false,
            statusmessages: [],
            languagetext: "",
            isSucess: false,
            editedIndex: -1,
            selectedlanguage: 0,
            selectedlangText: "",
            isSaveButtonActive: true,
            isUpdateAllButtonActive: true,
            addLanguageItem: {
                Id: 0,
                KeyId: 0,
                LanguageId: 0,
                Value: "",
            },
            editedItem: {
                id: 0,
                refId: 0,
                engRefId: 0,
                keyId: 0,
                key: "",
                english: "",
                selectedLanguageId: 0,
                selectedLanguage: "",
            },
            defaultItem: {
                id: 0,
                refId: 0,
                engRefId: 0,
                keyId: 0,
                key: "",
                english: "",
                selectedLanguageId: 0,
                selectedLanguage: "",
            },
            date: new Date().toISOString().substr(0, 10),
            dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
            searchUser: null,
            entries: [],
            useraccess: [],
            currentuser: [],
            isPageLoading: true,
            tableItemsPerPage: [25, 50, 100, -1],
            options: null,
        };
    },
    mounted() {
        this.getLanguagesFromAPI();
    },
    methods: {
        getLanguagesFromAPI() {
            var self = this;
            self.isPageLoading = true;
            const link =
                window.apiurl + "/MppiContractorLanguageMasters/GetLanguageMasterData";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.apilanguages = response.data;
                    self.getKeys();
                })
                .catch((error) => console.log(error));

            if (self.user != null) {
                const link2 =
                    window.apiurl + "/userheadcount/myview/" + self.user.userEmail;
                axios
                    .get(link2, {
                        withCredentials: true,
                        headers: self.requestHeaders
                    })
                    .then((response) => {
                        self.useraccess = response.data;
                        i18n.locale = self.useraccess[0].language;
                        if (self.useraccess[0].rowsPerPage != null) {
                            var rowsPrPg =
                                self.useraccess[0].rowsPerPage == "All" ?
                                -1 :
                                parseInt(self.useraccess[0].rowsPerPage);
                            self.options = {
                                itemsPerPage: rowsPrPg,
                            };
                        } else {
                            self.options = {
                                itemsPerPage: 25,
                            };
                        }
                    })
                    .catch((error) => console.log(error));
            } else {
                self.getUser();
            }
            self.getLanguages();
        },
        getLanguages() {
            var self = this;
            const link = window.apiurl + "/MppiContractorLanguages";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.alllangauges = response.data;
                })
                .catch((error) => console.log(error));
        },
        getKeys() {
            var self = this;
            const link = window.apiurl + "/MppiContractorLanguageKeys";
            axios
                .get(link, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.languagesTable = [];
                    if (response.data.length > 0) {
                        for (var j = 0; j < response.data.length; j++) {
                            var dKeyId = response.data[j].id;
                            var dKey = response.data[j].key;
                            var filterLangMast = [];
                            filterLangMast = self.apilanguages.filter(
                                (x) => x.keyId == dKeyId && x.languageId == 1
                            );
                            if (filterLangMast.length > 0) {
                                self.languagesTable.push({
                                    id: j + 1,
                                    refId: 0,
                                    engRefId: filterLangMast[0]._Id,
                                    keyId: dKeyId,
                                    key: dKey,
                                    english: filterLangMast[0].value,
                                    selectedLanguageId: 0,
                                    selectedLanguage: "",
                                });
                            } else {
                                self.languagesTable.push({
                                    id: j + 1,
                                    refId: 0,
                                    engRefId: 0,
                                    keyId: dKeyId,
                                    key: dKey,
                                    english: "",
                                    selectedLanguageId: 0,
                                    selectedLanguage: "",
                                });
                            }
                        }
                    }
                    self.isPageLoading = false;
                })
                .catch((error) => console.log(error));
        },
        selectedLangChanged() {
            if (this.selectedlanguage != 0) {
                var self = this;
                self.isUpdateAllButtonActive = false;
                for (var j = 0; j < self.languagesTable.length; j++) {
                    self.languagesTable[j].selectedLanguage = "";
                    self.languagesTable[j].refId = 0;
                    self.languagesTable[j].selectedLanguageId = self.selectedlanguage;

                    var dKeyId = self.languagesTable[j].keyId;
                    var filterLangMast = [];
                    filterLangMast = self.apilanguages.filter(
                        (x) => x.keyId == dKeyId && x.languageId == self.selectedlanguage
                    );
                    if (filterLangMast.length > 0) {
                        self.alllangauges.filter((x) => x.id == self.selectedlanguage);
                        self.languagesTable[j].selectedLanguage = filterLangMast[0].value;
                        self.languagesTable[j].refId = filterLangMast[0]._Id;
                    }
                }
                var ltext = self.alllangauges.filter(
                    (x) => x.id == self.selectedlanguage
                );
                self.selectedlangText = ltext[0].language;
            }
        },
        SaveLanguageData() {
            var self = this;
            var langMasterArray = [];
            for (var j = 0; j < self.languagesTable.length; j++) {
                langMasterArray.push({
                    Id: self.languagesTable[j].refId,
                    KeyId: self.languagesTable[j].keyId,
                    LanguageId: self.languagesTable[j].selectedLanguageId,
                    Value: self.languagesTable[j].selectedLanguage,
                });
                langMasterArray.push({
                    Id: self.languagesTable[j].engRefId,
                    KeyId: self.languagesTable[j].keyId,
                    LanguageId: 1,
                    Value: self.languagesTable[j].english,
                });
            }
            const link =
                window.apiurl + "/MppiContractorLanguageMasters/SaveLangKeyValueData";
            axios
                .post(link, langMasterArray, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then(function (response) {
                    self.$toast.clear();
                    self.$toast.success("Language changes updated successfully!");
                    self.getLanguagesFromAPI();
                    setTimeout(() => {
                        self.selectedLangChanged();
                        //self.$forceUpdate();
                        //HomeVue.$forceUpdate();
                        self.$router.go();
                    }, 1000);
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        getUser() {
            var self = this;
            axios
                .get(window.apiurl + "/usercontext", {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then((response) => {
                    self.currentuser = response.data;
                    const link4 =
                        window.apiurl +
                        "/userheadcount/myview/" +
                        self.currentuser.userEmail;
                    axios
                        .get(link4, {
                            withCredentials: true,
                            headers: self.requestHeaders
                        })
                        .then((response1) => {
                            self.useraccess = response1.data;
                            i18n.locale = self.useraccess[0].language;
                            self.isPageLoading = false;
                        })
                        .catch((error) => console.log(error));
                })
                .then(() => self.$store.commit("globalUser", self.currentuser))
                .catch((error) => console.log(error));
        },
        close(isCancel) {
            this.dialog = false;
            this.dialog1 = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
            if (isCancel == 1) {
                this.$toast.clear();
            }
        },
        editItem(item) {
            this.editedIndex = this.languagesTable.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },
        save() {
            var self = this;
            Object.assign(self.languagesTable[self.editedIndex], self.editedItem);
            var self = this;
            this.close();
            var langMasterArray = [];
            if (self.selectedlanguage != 0) {
                langMasterArray.push({
                    Id: self.languagesTable[self.editedIndex].refId,
                    KeyId: self.languagesTable[self.editedIndex].keyId,
                    LanguageId: self.languagesTable[self.editedIndex].selectedLanguageId,
                    Value: self.languagesTable[self.editedIndex].selectedLanguage,
                });
            }
            langMasterArray.push({
                Id: self.languagesTable[self.editedIndex].engRefId,
                KeyId: self.languagesTable[self.editedIndex].keyId,
                LanguageId: 1,
                Value: self.languagesTable[self.editedIndex].english,
            });
            const link =
                window.apiurl + "/MppiContractorLanguageMasters/SaveLangKeyValueData";
            axios
                .post(link, langMasterArray, {
                    withCredentials: true,
                    headers: self.requestHeaders
                })
                .then(function (response) {
                    self.getLanguagesFromAPI();
                    setTimeout(() => {
                        self.selectedLangChanged();
                        //self.$forceUpdate();
                        //HomeVue.$forceUpdate();
                    }, 1000);
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${month}/${day}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        },
    },
    computed: {
        formTitle() {
            return this.$t("selectedlanguagevalue");
        },
        computedDateFormatted() {
            return this.formatDate(this.date);
        },
        user() {
            return this.$store.state.userDetails;
        },
        hasGlobalAccess() {
            var globalaccess = false;
            var filterPlant = [];
            filterPlant = this.useraccess.filter((x) => x.plant == "Global");
            if (filterPlant != null && filterPlant.length > 0) {
                globalaccess = true;
            }
            return globalaccess;
        },
        rowsperpage() {
            return this.$t("rowsperpage");
        },
        isLoggedInUserActive() {
            var isuseractive = false;
            if (this.useraccess.length > 0) {
                this.useraccess.forEach(function (elem, index) {
                    if (elem.isActive == "Y") {
                        isuseractive = true;
                    }
                });
            }
            return isuseractive;
        },
        headers() {
            return [
                { text: this.$t("key"), align: "start", value: "key" },
                { text: this.$t("english"), value: "english" },
                { text: "Selected Language", value: "selectedLanguage" },
                { text: this.$t("actions"), value: "action", sortable: false },
            ];
        },
    },
    watch: {
        dialog(val) {
            val || this.close();
        },
        date(val) {
            this.dateFormatted = this.formatDate(this.date);
        },
    },
};
</script>



// WEBPACK FOOTER //
// ./src/components/Language.vue